import React from 'react'
import DatoTopNav from './DatoTopNav'
import { MdOutlineAlternateEmail } from "react-icons/md";
import { IoMail } from "react-icons/io5";
import { FaPhoneAlt } from "react-icons/fa";
import { BsGeoAltFill } from "react-icons/bs";

function DatosTopNavbar() {
  return (
    <div className='w-9/12 h-full pt-2 md:flex md:justify-evenly lg:justify-between lg:w-11-12'>
          <DatoTopNav dataRow={'text-GrisOscuro'} datoBox={"w-2/12"} item={<FaPhoneAlt size={15} />} dato={"+543815585138"}/>
          <DatoTopNav dataRow={'text-GrisOscuro'} datoBox={"w-2/12"} item={<IoMail size={15} />} dato={"administracion@agroh.info"}/>
          <DatoTopNav dataRow={'text-GrisOscuro'} datoBox={"w-2/12"} item={<MdOutlineAlternateEmail size={15} />} dato={"ventas@agroh.info"}/>
          <DatoTopNav dataRow={'text-GrisOscuro'} datoBox={"w-5/12"} item={<BsGeoAltFill size={15} />} dato={"Av.Gobernador del Campo 441, S.M. de Tucumán"}/>
      </div>
  )
}

export default DatosTopNavbar